var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[_c('button',{staticClass:"close-button",on:{"click":_vm.removeCardFromList}},[_vm._v(" × ")]),_c('div',{staticClass:"body"},[_vm._v(" "+_vm._s(_vm.body)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }